module.exports = __webpack_public_path__ + "img/1.de41f092.jpg";